<template>
  <div id="app">
    <div id="nav">
      <Topbar />
      <!-- <Home /> -->
      <router-view/>
      <Footer />
    </div>
    <!-- <transition name="fade">
      <div id="pagetop" class="fixed right-0 bottom-0" v-show="scY > 300" @click="toTop">
        <h5>Back To Top</h5>
      </div>
    </transition> -->
    <!-- <transition name="fade">
      <div id="pagetop" class="fixed right-0 bottom-0" @click="backToMenu">
        <h5>Kembali Ke Acara</h5>
      </div>
    </transition> -->
  </div>
</template>

<script>
import Topbar from '@/layouts/Topbar.vue'
import Footer from '@/layouts/Footer.vue'
// import Home from '@/views/Home.vue'

export default {
  name: 'App',
  data () {
    return {
      scTimer: 0,
      scY: 0,
    }
  },
  components: {
    Topbar,
    Footer,
    // Home
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
    // const menu = this.$route.params.menu 
    // console.log(menu)
    // if (menu == true) {
    //   console.log('menu', menu)
    //   window.scrollTo({
    //     top: 800 , behavior: 'smooth'
    //   })
    // }
  },
  methods: {
    // backToMenu() {
    //   this.$router.push({name: "Home" , params: {menu: true}})
    // }
    // handleScroll: function () {
    //   if (this.scTimer) return;
    //   this.scTimer = setTimeout(() => {
    //     this.scY = window.scrollY;
    //     clearTimeout(this.scTimer);
    //     this.scTimer = 0;
    //   }, 100);
    // },
    // toTop: function () {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: "smooth"
    //   });
    // },
  },
}
</script>
